import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IActivitiesQuantityPerStudentFilters } from 'presentation/app/modules/Reports/models/activities-quantity-per-student-filters';

interface IProfessionalsWorkJourneyState {
  filters: IActivitiesQuantityPerStudentFilters;
}

interface IPayloadActivitiesQuantityPerStudentFilters
  extends PayloadAction<IActivitiesQuantityPerStudentFilters> {}

const initialState: IProfessionalsWorkJourneyState = {
  filters: null,
};

export const ActivitiesQuantityPerStudentSlice = createSlice({
  name: 'activities-quantity-per-student',
  initialState,
  reducers: {
    loadFilters: (
      state,
      action: IPayloadActivitiesQuantityPerStudentFilters,
    ) => {
      state.filters = action.payload;
    },
    clearFilters: (state) => {
      state.filters = null;
    },
  },
});

export const { loadFilters, clearFilters } =
  ActivitiesQuantityPerStudentSlice.actions;

export default ActivitiesQuantityPerStudentSlice.reducer;
